// extracted by mini-css-extract-plugin
export default {"tabs":"LanguageTabs_tabs__fiQhR"};